import React, {Fragment} from 'react';
import PropTypes from "prop-types";
import CsfMembreUtils from "../utils/CsfMembreUtils";

export default function CsfMembreActivitiesTable({member, activities, setSelectedActivity, periodTitle, periodSubTitle = '', collapse=false, printId, setCheckedPrintOption, periodInOrder, isCurrentPeriodActivity}) {

  const accordionId = `activities__accordeon-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
  const language = document.documentElement.lang;

  const determineIfUserCanEdit = (activity) => {
    return isCurrentPeriodActivity && activity?.Saisi_par_contact === member.Contact_Id && activity?.Presence_Status == "AAAAAAAAAAI="; //@This is hardcoded as specified in the documentation
  }

  return (
    <>
      <h2 className="mb-6">
        { periodTitle }
        <span>{ periodSubTitle }</span>
      </h2>
      { !collapse && (
        <div className="d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center mb-1">
          <p className="m-0 mr-md-4">{window.Drupal.t('membre.activities.accessAll.text')}</p>
          {/* <button className="espaces__table-accordion" type="button">{window.Drupal.t('membre.activities.btn.all.label')}</button> //FUTURE PHASE */}
        </div>
      )}
      <div className="activities__legend mb-1 d-flex flex-wrap flex-md-nowrap justify-content-between align-items-end">
        <div className="activities__tag-wrapper d-flex flex-column flex-md-row mr-md-2 mb-1 mb-md-0 w-100 w-md-auto">

          {periodInOrder ? (
            <span className="espaces__tag">{window.Drupal.t('membre.completeUFC.tag')}</span>
          ) : (
            <span className="espaces__tag espaces__tag--error">{window.Drupal.t('membre.incompleteUFC.tag')}</span>
          )}

        </div>
        <div className="accordion ml-auto" id={accordionId}>
          <div className="accordion-item">
            <h2 className="m-0">
              <button
                className="espaces__table-accordion d-flex align-items-center"
                type="button" data-toggle="collapse"
                data-target={`#${accordionId}__current-btn`} aria-expanded={!collapse}
                aria-controls={`${accordionId}__current-btn`}>
                <span>{window.Drupal.t('Details')}</span>
                <img className="img-arrow" alt="chevron"
                  src="/themes/custom/tink/dist/assets/chevron-left.svg"
                />
              </button>
            </h2>
          </div>
        </div>
      </div>
      <div id={`${accordionId}__current-btn`} className={`accordion-collapse collapse ${collapse ? '' : 'show' }`}>
        <div className="accordion-body">
          <div className="inner-wrapper">
            <div className="table-wrapper">
              <table className="activities__table">
                <thead>
                <tr>
                  <th>
                    {window.Drupal.t('fournisseur.activities-list.table.number')}
                  </th>
                  <th>
                    {window.Drupal.t('membre.activities.activityTitle')}
                  </th>
                  <th width="120">
                    {window.Drupal.t('membre.activities.attendanceDate')}
                  </th>
                  <th>
                    {window.Drupal.t('PDU')}
                  </th>
                </tr>
                </thead>
                <tbody>
                {activities?.length === 0 && (
                  <tr>
                    <td colSpan="6">
                      <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
                    </td>
                  </tr>
                )}
                {[...new Map(activities.map(item => [item.Activite_Id, item])).values()].map(item => (
                  <Fragment key={item.Activite_Id}>
                    <tr className="activities__base-info">
                      <td>
                        {item?.Recognition_Code}
                      </td>
                      <td>
                        {item?.Activite_Id__Rn_Descriptor}
                      </td>
                      <td>
                        {CsfMembreUtils.getFormattedDate(item?.Suivi_Le)}
                      </td>
                      <td>
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="mr-1">{item?.SousTotal}&nbsp;{window.Drupal.t('PDU')}</span>
                          <button className="table-accordion"
                                  type="button" data-toggle="collapse"
                                  data-target={`#${item?.Activite_Id?.replace('=','')}__content-${collapse ? 'previous' : 'current' }`} aria-expanded="false"
                                  aria-controls={`${item?.Activite_Id?.replace('=','')}__content-${collapse ? 'previous' : 'current' }`}
                                  aria-label={`${item?.Activite_Id__Rn_Descriptor} - ${window.Drupal.t('membre.summary.detail.aria-label')}`}>
                            <img className="img-arrow"
                                 src="/themes/custom/tink/dist/assets/chevron-left.svg" alt="chevron"/>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr className="activities__more-info">
                      <td colSpan="4" className="p-0">
                        <div id={`${item?.Activite_Id?.replace('=','')}__content-${collapse ? 'previous' : 'current' }`} className="accordion-collapse collapse">
                          <div className="d-flex align-items-center">
                            {determineIfUserCanEdit(item) && (
                              <>
                                <button type="button" className='button btn-outlined btn-icon-only mr-2'
                                        title={window.Drupal.t('Edit')}
                                        data-toggle="modal" data-target="#membreActivitiesModal-table"
                                        onClick={() => setSelectedActivity(item)}>
                                  <i className="icon icon-csf-edit supplier-icon">
                                    <span className="d-none">&nbsp;</span>
                                  </i>
                                </button>
                                <p className="m-0">{window.Drupal.t('membre.activities.row.yourself')}</p>
                              </>
                            )}
                            { item?.IsCurrentUserTrainer && (
                              <p className="m-0 ml-auto">{window.Drupal.t('membre.activities.isTrainer')}</p>
                            )}
                          </div>
                          <div className="activities__tag-list d-flex flex-wrap flex-md-no-wrap">
                            {
                              Object.entries(item?.activityCourses)?.filter(([key]) => !key.toLowerCase().includes("gsft"))?.map(([key, value], index) => (
                                <span key={`${item.Activite_Id}-tag-${index}`} className="activities__tag">
                                  <span>{key}</span>
                                  <span>­{value ? `+ ${value} ${window.Drupal.t('PDU')}` : window.Drupal.t('membre.tag.na')}</span>
                                </span>
                              ))
                            }
                          </div>
                        </div>
                      </td>
                    </tr>

                  </Fragment>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-end">
            <button className='button btn-outlined btn-with-icon mb-2' onClick={() => setCheckedPrintOption(printId)}
                    type="button" data-toggle="modal" data-target="#membrePrintModal">
              <i className="icon icon-print supplier-icon"><span className="d-none">&nbsp;</span></i>
              {window.Drupal.t('membre.btn.print.label')}
            </button>
          </div>
        </div>
      </div>
    </div>
</>
)
}

CsfMembreActivitiesTable.propTypes = {
  member: PropTypes.object,
  activities: PropTypes.array,
  setSelectedActivity: PropTypes.func,
  periodTitle: PropTypes.string,
  periodSubTitle: PropTypes.string,
  collapse: PropTypes.bool,
  printId: PropTypes.string,
  setCheckedPrintOption: PropTypes.func,
  periodInOrder: PropTypes.bool,
  isCurrentPeriodActivity: PropTypes.bool,
};
